import { type ResourcesConfig } from 'aws-amplify';

// Amplify's OAuth config expects the bare Cognito Hosted UI hostname (no protocol, no trailing slash).
const cognitoDomain = (import.meta.env.VITE_COGNITO_DOMAIN ?? '').replace(/^https?:\/\//, '').replace(/\/+$/, '');
const appOrigin = typeof window !== 'undefined' ? window.location.origin : '';

// Must exactly match the URLs whitelisted on the Cognito app client (CallbackURLs / LogoutURLs).
const FEDERATED_CALLBACK_PATH = '/auth/federated/login';
const federatedCallbackUrl = `${appOrigin}${FEDERATED_CALLBACK_PATH}`;

const loginWith: NonNullable<NonNullable<ResourcesConfig['Auth']>['Cognito']>['loginWith'] = {
    email: true,
    ...(cognitoDomain && {
        oauth: {
            domain: cognitoDomain,
            scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [federatedCallbackUrl],
            redirectSignOut: [federatedCallbackUrl],
            responseType: 'code',
            providers: ['Google'],
        },
    }),
};

const amplifyConfig: ResourcesConfig = {
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
            userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '',
            loginWith,
            mfa: {
                status: 'on',
                totpEnabled: true,
            },
        },
    },
};

export default amplifyConfig;
